import {Button, Card, Col, List, message, Row} from "antd";
import {Spacer} from "../../../../../components/DesignSystem/Spacer/Spacer";
import React from "react";
import {FormattedDate} from "../../../../../components/DesignSystem/Moment/FormattedDate";
import fileSize from "filesize";
import {FileTextOutlined} from "@ant-design/icons";
import styles from "./UserFilesList.module.css";
import {useHistory} from "react-router-dom";
import {fileService} from "../../../../../services/fileService";
import {showConfirm} from "../../../../../components/File/AvailableFiles";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";

export const UserFilesList = ({data, onDeleted}) => {

    const history = useHistory();

    const handleOpenFile = (fileId) => {
        history.push(`/view/${fileId}/preview`);
    }

    const handleDeleteFile = (fileId, fileName) => {

        showConfirm("Confirmation", `Do you really want to delete the file <strong>${fileName}?</strong>`, () => {

            fileService.deleteFile(fileId).then(() => {
                message.info("File deleted successfully");
                onDeleted && onDeleted(fileId);
            }).catch(error => {
                message.error("Error deleting file");
            });

        });

    }

    return <div style={{maxHeight: '600px', overflowY: "auto"}}>
            <List
                grid={{ gutter: 16, column: 3 }}
                dataSource={data}
                renderItem={item => (
                    <List.Item>
                        <Card style={{minHeight: '80'}}>
                            <div className={styles.label}><FileTextOutlined/>{'  '}{item.name}</div>
                            <div style={{color: 'silver'}}>{fileSize(item.size)} * <FormattedDate value={item.createdAt}/></div>
                            <Spacer/>
                            <Row wrap={false}>
                                <Col flex="auto">
                                    <Button onClick={e => handleOpenFile(item.id)} block>View</Button>
                                </Col>
                                <Col flex="none">
                                    &nbsp;&nbsp;<Button icon={<DeleteOutlined/>} onClick={e => handleDeleteFile(item.id, item.name)}/>
                                </Col>
                            </Row>
                        </Card>
                    </List.Item>
                )}
            />
            <Spacer size={"large"}/>
    </div>

}